import * as Yup from "yup";
import { MAX_CURRENCY_AMOUNT } from "utils/tools";

const amount = (label: string) => Yup.number()
    .typeError(`${label} must be a number`)
    .min(0, `${label} cannot be negative`)
    .max(MAX_CURRENCY_AMOUNT, `${label} cannot exceed ${MAX_CURRENCY_AMOUNT}`)
    .required(`${label} is required`);

// Blank = no target
const optionalNumber = (label: string, max: number) => Yup.number()
    .transform((value, original) => (original === '' || original === null ? undefined : value))
    .typeError(`${label} must be a number`)
    .min(0, `${label} cannot be negative`)
    .max(max, `${label} cannot exceed ${max}`)
    .notRequired();

export const DepartmentKPIFormValidation = Yup.object({
    branchId: Yup.string()
        .required("Branch is required"),
    fiscalYear: Yup.number()
        .typeError("Fiscal Year must be a number")
        .required("Fiscal Year is required"),
    budget: amount("Budget"),
    annualRevenue: amount("Annual Revenue"),
    grossMargin: amount("Gross Margin"),
    workInHand: amount("Work In Hand"),
    performanceManagement: Yup.string()
        .required("Performance Management is required")
        .min(1)
        .max(255),
    blueZone: amount("Blue Zone"),
    yellowZone: amount("Yellow Zone"),
    opportunityWinTotal: amount("Opportunity Win Total"),
    projectProfitability: amount("Project Profitability"),
    arOverdueTarget: optionalNumber("AR Overdue target", MAX_CURRENCY_AMOUNT),
    turnoverTarget: optionalNumber("Turnover target", 100),
    winRateTarget: optionalNumber("Win Rate target", 100),
});
